import { getCookie } from '@/utils/tool'
import { setCookie } from '@/utils/login'
import { getDomain } from '@/utils/utils'

function getRandomStr() {
  // 生成伪随机数
  const randFunc = () => Math.random().toString().slice(2, 12)
  let str = randFunc()
  while (str.length < 10) {
    str += randFunc()
  }
  return str.slice(0, 10)
}

export const getClientToken = () => {
  const cacheId = getCookie('clientToken')
  let reg = new RegExp(/\d{10}_\d{13}/)
  if (cacheId && reg.test(cacheId)) {
    return cacheId
  } else {
    let clientToken = getRandomStr() + '_' + new Date().getTime()
    setCookie('clientToken', clientToken, 90, getDomain())
    return clientToken
  }
}

// 获取uvid
export const getUvid = () => {
  const cookie = getCookie('_ga') || ''
  // const res = cookie.split(/GA[0-9]\.[0-9]\./) || []
  // const originId = res[1]
  // return Number(originId).toString(36).replace('.', 'kicoin') || 'anonymous'
  return cookie || 'anonymous'
}

export const getUvidForServer = () => {
  return getCookie('_ga') || ''
}

// 间隔调用getter函数，等到有返回值时终止。
export function waitFor(getter, callback) {
  let clearTimerId = null
  let timerId = setInterval(() => {
    const result = getter()
    // 非undefined时，认为已获取到结果
    if (result !== undefined) {
      clearInterval(timerId)
      clearTimeout(clearTimerId)
      callback(result)
    }
  }, 300)
  // 超时1分钟后不再执行
  clearTimerId = setTimeout(() => clearInterval(timerId), 60000)
}

// 判断是否在灰度的比例内。
// 借助clientToken值来处理，目的是确保：比如灰度从0.1提高到0.2时，之前0.1时覆盖的用户，依然生效。
// scale灰度值在[0~1]范围内: 1表示全量, 0表示关闭，0~1之间，表示相应的百分比值，比如0.01, 表示1%的量。
export function isInABTest(scale) {
  const clientToken = getClientToken()
  let num = Number(scale)
  if (isNaN(num) || num === 0) {
    return false
  } else if (num === 1) {
    return true
  } else {
    // eg: 0.025 => 025
    const temp = String(num).substring(2)
    // clientToken长度是10位
    if (temp.length > 10) {
      return false
    }
    num = Number(temp)
    const value = Number(clientToken.substring(0, temp.length))
    return value < num
  }
}

// uvid末尾是否为奇数
export const uvidIsOdd = () => {
  const lastChar = getUvid().slice(-1) || 1
  return lastChar % 2 === 1
}
